import { render } from "./TableListBody.vue?vue&type=template&id=47a5ff55&scoped=true"
import script from "./TableListBody.vue?vue&type=script&lang=js"
export * from "./TableListBody.vue?vue&type=script&lang=js"

import "./TableListBody.vue?vue&type=style&index=0&id=47a5ff55&lang=scss"
import "./TableListBody.vue?vue&type=style&index=1&id=47a5ff55&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a5ff55"]])

export default __exports__